// This component is rendered only for the English storefront.
// Shopify delivery rates remain authoritative for the final checkout address.
const selector = 'cielohuk-international-limit';

class InternationalLimit extends HTMLElement {
  static observedAttributes = ['data-weight'];

  connectedCallback() {
    this.onClick ??= (event) => {
      if (event.target.closest('[data-close-delivery]')) this.dialog.close();
    };
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.dialog?.close();
  }

  attributeChangedCallback() {
    // Quantity updates invalidate the open warning.
    this.dialog?.close();
  }

  get dialog() { return this.querySelector('dialog'); }
  get scope() { return this.closest('hdt-main-cart, hdt-cart-drawer'); }

  showWarning() {
    if (!this.dialog.open) this.dialog.showModal();
  }
}

if (!customElements.get(selector)) customElements.define(selector, InternationalLimit);

function guardCheckout(event) {
  const button = event.type === 'submit' ? event.submitter : event.target.closest('[name="checkout"], a[href*="/checkout"]');
  if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
  const formId = button.form?.getAttribute('id');
  const limit = [...document.querySelectorAll(selector)].find((element) =>
    Number(element.dataset.weight) >= 10000 && (element.dataset.form === formId || element.scope?.contains(button)));
  if (!limit) return;
  if (button.form?.checkBreak) return;
  if (button.form && !button.form.reportValidity()) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  limit.showWarning();
}

document.addEventListener('click', guardCheckout, true);
document.addEventListener('submit', guardCheckout, true);
